import { useLanguage } from "../context/LanguageContext";
import { Reveal, MaskedLine } from "../components/motion";

const renderLegalText = (text) =>
  text.split(/(https?:\/\/[^\s]+|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/g).map((part, i) => {
    if (/^https?:\/\//.test(part)) {
      return (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="text-ink underline decoration-ink/30 underline-offset-4 transition-colors hover:text-deep hover:decoration-deep"
        >
          {part}
        </a>
      );
    }
    if (/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(part)) {
      return (
        <a
          key={i}
          href={`mailto:${part}`}
          className="text-ink underline decoration-ink/30 underline-offset-4 transition-colors hover:text-deep hover:decoration-deep"
        >
          {part}
        </a>
      );
    }
    return <span key={i}>{part}</span>;
  });

export default function LegalPage({ page }) {
  const { t } = useLanguage();
  const d = t.legal[page];
  return (
    <main data-testid={`${page}-page`} className="bg-paper">
      <section className="bg-deep pb-20 pt-36 text-white sm:pb-24 sm:pt-44">
        <div className="mx-auto max-w-[1600px] px-6 sm:px-12 md:px-16">
          <Reveal y={14}>
            <p className="text-[11px] font-medium uppercase tracking-label text-wave">{d.label}</p>
          </Reveal>
          <h1 className="font-head mt-6 text-4xl tracking-tight sm:text-6xl">
            <MaskedLine delay={0.1}>{d.title}</MaskedLine>
          </h1>
          <Reveal delay={0.3}>
            <p className="mt-5 text-[11px] uppercase tracking-[0.2em] text-white/40">{d.updated}</p>
          </Reveal>
        </div>
      </section>
      <section className="mx-auto max-w-[1600px] px-6 py-20 sm:px-12 sm:py-28 md:px-16">
        <div className="max-w-2xl">
          {d.sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.05} className="border-t border-ink/10 py-8 first:border-t-0 first:pt-0">
              <h2 className="font-head text-xl text-ink sm:text-2xl">{s.h}</h2>
              <p className="mt-4 whitespace-pre-line text-base font-light leading-relaxed text-ink/70">{renderLegalText(s.p)}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
